import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-companypage',
    templateUrl: './companypage.component.html',
    styleUrls: ['./companypage.component.scss'],
    standalone: false
})
export class CompanypageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
